export const GET_TAGS = 'get_tags';
export const TOGGLE_PDP_MODAL = 'toggle_pdp_modal';
export const TOGGLE_RDP_MODAL = 'toggle_rdp_modal';
